/* eslint-disable */
Number.isNaN = Number.isNaN || function isNaN (input) {
  return typeof input === 'number' && input !== input
}